<header class="header --{{ headerClass }}">
  <div class="wrapper">
    <a [routerLink]="(languageService.currentLanguage$ | async) === 'en' ? '' : PATHS[ROUTES.HOME_DE]">
      <app-logo></app-logo>
    </a>
    <ul class="header__nav">
      <li class="header__nav__item">
        <a
          [routerLink]="(languageService.currentLanguage$ | async) === 'en' ? PATHS[ROUTES.WHAT] : PATHS[ROUTES.WHAT_DE]"
          title="What"
          class="header__nav__link"
        >
          <ng-container *ngIf="(languageService.currentLanguage$ | async) === 'en'">What</ng-container>
          <ng-container *ngIf="(languageService.currentLanguage$ | async) === 'de'">Was</ng-container>
        </a>
      </li>
      <li class="header__nav__item">
        <a
          [routerLink]="(languageService.currentLanguage$ | async) === 'en' ? PATHS[ROUTES.WORKS] : PATHS[ROUTES.WORKS_DE]"
          title="Works"
          (mouseenter)="preloadWorksImages()"
          class="header__nav__link"
        >
          <ng-container *ngIf="(languageService.currentLanguage$ | async) === 'en'">Works</ng-container>
          <ng-container *ngIf="(languageService.currentLanguage$ | async) === 'de'">Projekte</ng-container>
        </a>
      </li>
      <li class="header__nav__item">
        <a
          [routerLink]="(languageService.currentLanguage$ | async) === 'en' ? PATHS[ROUTES.NEARSHORING_EN] : PATHS[ROUTES.NEARSHORING_DE]"
          title="Nearshoring"
          class="header__nav__link"
          >Nearshoring</a
        >
      </li>
      <li class="header__nav__item">
        <app-language-selector></app-language-selector>
      </li>
    </ul>
  </div>
</header>
